export const ESTATE_STATUS = {
  REGISTERED: 'REGISTERED',
  CONSIGNED: 'CONSIGNED',
  PUBLISHED: 'PUBLISHED',
  RESERVED: 'RESERVED',
  LEASED: 'LEASED',
  PAUSED: 'PAUSED',
  BANNED: 'BANNED',
};

export const COUNTRY_CODE = {
  COLOMBIA: 'CO',
  MEXICO: 'MX',
};

export const FAQSData = [
  {
    question: '¿Este inmuebles se arrienda directamente con el propietario?',
    answer:
      '¡No te preocupes! Aquí firmas con el propietario y nosotros nos encargamos de administrarlo. Es mucho más fácil que con una inmobiliaria tradicional.',
  },
  {
    question: '¿Se necesita codeudor para este inmueble?',
    answer:
      'Dependerá del resultado de tu evaluación. Con nuestro estudio de crédito ágil, necesitas tener tu documentación al día y no estar reportado en centrales de riesgo, en pocos minutos tendrás los resultados (Aplican TyC)',
  },
  {
    question: '¿Qué documentos necesito para aplicar a este inmueble?',
    answer:
      '¡Arrendar el lugar de tus sueños es muy fácil! Puedes hacerlo sin salir de casa, sin trámites aburridos y en línea, solo debes tener listo los siguientes documentos:',
    subanswer: (
      <ul>
        <li>Tus extractos bancarios (últimos 3 meses)</li>
        <li>Declaración de renta del año anterior (Solo si aplica)</li>
        <li>Fotocopia de tu documento de identidad</li>
        <li>Certificado laboral con salario (si eres empleado)</li>
        <li>RUT y Cámara de comercio (si eres independiente, cámara de comercio solo si aplica)</li>
      </ul>
    ),
  },
];


